import * as actionTypes from './actions';

// Redux 的“传统用法”
// 在 Redux Toolkit (RTK) 出现之前，Redux 是这样用的：
// 1.	定义 reducer 函数（负责根据 action 更新 state）
// 2.	创建 store，把 reducer 传进去
// 3.	定义 action（一个个对象）
// 4.	在组件里 dispatch action

export const initialState = {
  realUser: undefined, // 真实用户
  user: undefined
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {
        ...state,
        realUser: action.payload,
        user: action.payload
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        realUser: undefined,
        user: undefined
      };
    case actionTypes.IMPERSONATE:
      const newUser = action.payload;
      return {
        ...state,
        user: newUser
      };
    case actionTypes.REVERT:
      const adminUser = state.realUser;
      return {
        ...state,
        user: adminUser
      };
    case actionTypes.REAL_USER:
      return {
        ...state,
        realUser: action.payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
